import Grid from "@mui/material/Grid";
import { ClientAgendaApiData } from "./type";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React, { useEffect } from "react";
import { agendaContainer } from "../../project-agenda/project-agenda-description/styles";
import { Stack, Typography } from "@mui/material";

type Props = {
    agendaData: ClientAgendaApiData["agendas"]
}

export default function ExpertTab({agendaData}: Props) {
    const [agenda, setAgenda] = React.useState<ClientAgendaApiData["agendas"][0]>(agendaData[0]);

    const handleChange = (event: React.MouseEvent<HTMLElement>, nextAgenda: ClientAgendaApiData["agendas"][0]) => {
        if(nextAgenda) {
            setAgenda(nextAgenda);
        }
    };

     useEffect(() => {
            setAgenda(agendaData[0]);
        },[])
    


    return (
        <>
        <Grid container>
            <Grid item xs={12} sm={3} sx={{overflow: "scroll", height: {
                sm: "500px",
                xs: "initial"
            }, maxHeight: {xs: "200px", sm: "500px"}}}>
            <ToggleButtonGroup
                orientation="vertical"
                value={agenda}
                exclusive
                onChange={handleChange}
                fullWidth
                >
                    {agendaData.map((d, index) => 
                        <ToggleButton sx={{textTransform: "capitalize"}} value={d} aria-label={String(d.id)}>
                            Agenda {index + 1 > 9 ? `0${index + 1}` : index + 1}
                        </ToggleButton>
                    )}
                </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sm={9} sx={{overflow: "scroll", border: "1px solid #252B3B75", height: "500px"}}>
                {agenda &&
                    <Grid item container sx={agendaContainer}>
                        {agenda.agenda_responses?.map((response, index: number) => (
                          <Grid xs={12} item key={index + response.ques}>
                            <Stack direction={"row"} spacing={1} mr={4} mt={2}>
                              <Typography
                                fontSize={"12px"}
                                fontWeight={600}
                                sx={{ color: "#252B3B", opacity: "0.85" }}
                              >
                                Q{index + 1}.
                              </Typography>
                              <Stack flex={1} rowGap={1}>
                                <Typography
                                  fontSize={"12px"}
                                  fontWeight={600}
                                  sx={{ color: "#484C57" }}
                                >
                                  {response.ques}
                                </Typography>
                                {response.responses.map((response, index) => (
                                  <>
                                  <Typography
                                    fontSize={"12px"}
                                    fontWeight={600}
                                    sx={{ color: "#484C57", opacity: "0.9" }}
                                  >
                                    • {response.expert_name}
                                  </Typography>
                                  <Grid ml={"10px"} container direction={"row"}>
                                    <Grid item xs={12} sm={4} md={2}>
                                      <Typography
                                        fontSize={"12px"}
                                        fontWeight={600}
                                        sx={{
                                          color: "#484C57",
                                          opacity: "0.75",
                                        }}
                                      >
                                        Response -
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={8} md={10}>
                                      <Typography
                                        fontSize={"12px"}
                                        fontWeight={600}
                                        sx={{
                                          color: "#099A51",
                                          opacity: "0.75",
                                        }}
                                      >
                                        {response?.answer}
                                      </Typography>
                                    </Grid>
                                </Grid>
                                {response.expert_note && (
                                  <Grid ml={"10px"} container direction={"row"}>
                                    <Grid item xs={12} sm={4} md={2}>
                                      <Typography
                                        fontSize={"12px"}
                                        fontWeight={600}
                                        sx={{
                                          color: "#484C57",
                                          opacity: "0.75",
                                        }}
                                      >
                                        Note -
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={8} md={10}>
                                      <Typography
                                        fontSize={"12px"}
                                        fontWeight={500}
                                        sx={{
                                          color: "#484C57",
                                          opacity: "0.75",
                                        }}
                                      >
                                        {response.expert_note}
                                      </Typography>
                                    </Grid>
                                  </Grid>)}
                                  </>
                                ))}
                              </Stack>
                            </Stack>
                            <hr style={{ opacity: "0.75", margin: "0.75rem 0" }} />
                          </Grid>
                        ))}
                    </Grid>}
            </Grid>
        </Grid>
    </>
    )
}